export const GET_MASTER_COURSES_COUNTRIES_REQUEST = 'GET_MASTER_COURSES_COUNTRIES_REQUEST';

export const getMasterCoursesCountries = () =>
    ({ type: GET_MASTER_COURSES_COUNTRIES_REQUEST });

export const GET_DEFAULT_COURSES_FOR_COUNTRY_REQUEST = 'GET_DEFAULT_COURSES_FOR_COUNTRY_REQUEST';
export const GET_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS = 'GET_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS';
export const GET_DEFAULT_COURSES_FOR_COUNTRY_FAILURE = 'GET_DEFAULT_COURSES_FOR_COUNTRY_FAILURE';

export const getDefaultCoursesForCountryRequest = (accessCode, productId) =>
    ({ type: GET_DEFAULT_COURSES_FOR_COUNTRY_REQUEST, accessCode, productId });

export const getDefaultCoursesForCountrySuccess = defaultCourses =>
    ({ type: GET_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS, defaultCourses });

export const getDefaultCoursesForCountryFailure = () =>
    ({ type: GET_DEFAULT_COURSES_FOR_COUNTRY_FAILURE });

export const GET_COURSES_FOR_COUNTRY_REQUEST = 'GET_COURSES_FOR_COUNTRY_REQUEST';
export const GET_COURSES_FOR_COUNTRY_SUCCESS = 'GET_COURSES_FOR_COUNTRY_SUCCESS';
export const GET_COURSES_FOR_COUNTRY_FAILURE = 'GET_COURSES_FOR_COUNTRY_FAILURE';

export const getCoursesForCountryRequest = (countryCode, productId) =>
    ({ type: GET_COURSES_FOR_COUNTRY_REQUEST, countryCode, productId });

export const getCoursesForCountrySuccess = courses =>
    ({ type: GET_COURSES_FOR_COUNTRY_SUCCESS, courses });

export const getCoursesForCountryFailure = () =>
    ({ type: GET_COURSES_FOR_COUNTRY_FAILURE });

export const SAVE_DEFAULT_COURSES_FOR_COUNTRY_REQUEST = 'SAVE_DEFAULT_COURSES_FOR_COUNTRY_REQUEST';
export const SAVE_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS = 'SAVE_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS';
export const SAVE_DEFAULT_COURSES_FOR_COUNTRY_FAILURE = 'SAVE_DEFAULT_COURSES_FOR_COUNTRY_FAILURE';

export const saveDefaultCoursesForCountryRequest = (accessCode, productId, defaultCourses) =>
    ({ type: SAVE_DEFAULT_COURSES_FOR_COUNTRY_REQUEST, accessCode, productId, defaultCourses });

export const saveDefaultCoursesForCountrySuccess = defaultCourses =>
    ({ type: SAVE_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS, defaultCourses });

export const saveDefaultCoursesForCountryFailure = () =>
    ({ type: SAVE_DEFAULT_COURSES_FOR_COUNTRY_FAILURE });

export const GET_COURSES_REQUEST = 'GET_COURSES_REQUEST';
export const GET_COURSES_SUCCESS = 'GET_COURSES_SUCCESS';
export const GET_COURSES_FAILURE = 'GET_COURSES_FAILURE';

export const getCoursesRequest = (accessStatus, countryCode, stateCode, productId) =>
    ({ type: GET_COURSES_REQUEST, accessStatus, countryCode, stateCode, productId });

export const getCoursesSuccess = courses =>
    ({ type: GET_COURSES_SUCCESS, courses });

export const getCoursesFailure = () =>
    ({ type: GET_COURSES_FAILURE });

export const SAVE_DEFAULT_COURSES_REQUEST = 'SAVE_DEFAULT_COURSES_REQUEST';
export const SAVE_DEFAULT_COURSES_SUCCESS = 'SAVE_DEFAULT_COURSES_SUCCESS';
export const SAVE_DEFAULT_COURSES_FAILURE = 'SAVE_DEFAULT_COURSES_FAILURE';

export const saveDefaultCoursesRequest = (accessStatus, countryCode, stateCode, productId, defaultCourses) =>
    ({ type: SAVE_DEFAULT_COURSES_REQUEST, accessStatus, countryCode, stateCode, productId, defaultCourses });

export const saveDefaultCoursesSuccess = defaultCourses =>
    ({ type: SAVE_DEFAULT_COURSES_SUCCESS, defaultCourses });

export const saveDefaultCoursesFailure = () =>
    ({ type: SAVE_DEFAULT_COURSES_FAILURE });



// WEBPACK FOOTER //
// ./app/containers/set-default-courses/actions.js